'use strict';

window.TYPES_STATUS_OPERATIONS = {
  neutro: {
    color: '#dddddd',
    colorDescription: 'branco',
    description: 'Neutro'
  },
  equilibrio: {
    color: '#2ECC71',
    colorDescription: 'verde',
    description: 'Baixa',
    cor: '#2ECC71',
    corInimigoNatural: '#e74c3c',
    descricao: 'Baixa',
    id: 1,
    descricaoJson: 'equilibrio'
  },
  alto_equilibrio: {
    color: '#2196f3',
    cor: '#2196f3',
    corInimigoNatural: '#2196f3',
    colorDescription: 'azul',
    description: 'Baixa Média',
    id: 2,
    descricaoJson: 'alto_equilibrio'
  },
  controle: {
    color: '#F1C40F',
    cor: '#F1C40F',
    corInimigoNatural: '#F1C40F',
    colorDescription: 'amarelo',
    description: 'Média',
    id: 3,
    descricaoJson: 'controle'
  },
  // TODO: deveria considerar somente 'emergencia' que é como vem do app
  alerta: {
    color: '#e74c3c',
    cor: '#e74c3c',
    corInimigoNatural: '#2ECC71',
    colorDescription: 'vermelho',
    description: 'Alta',
    id: 4,
    descricaoJson: 'alerta'
  },
  emergencia: {
    color: '#e74c3c',
    cor: '#e74c3c',
    corInimigoNatural: '#2ECC71',
    colorDescription: 'vermelho',
    description: 'Alta',
    id: 4,
    descricaoJson: 'alerta' // TODO: deveria ser 'emergencia'
  },
  extremo: {
    color: '#9c27b0',
    cor: '#9c27b0',
    corInimigoNatural: '#9c27b0',
    colorDescription: 'roxo',
    description: 'Extremo',
    id: 5,
    descricaoJson: 'extremo'
  }
};

window.TYPES_DESCRIPTIONS_OPERATIONS = {
  stand: {
    description: 'Contagem Stand',
    hasGroup: true,
    isGeneral: true,
    hasSide: true,
    role: 'contagem'
  },
  produtividade: {
    description: 'Estimativa de Produtividade',
    hasGroup: true,
    hasSide: true,
    role: 'contagem'
  },
  visita: {
    description: 'Visita',
    hasGroup: false,
    isGeneral: true
  },
  inseto: {
    description: 'Inseto',
    hasGroup: true,
    role: 'ocorrencia'
  },
  doenca: {
    description: 'Doença',
    hasGroup: true,
    role: 'ocorrencia'
  },
  invasora: {
    description: 'Invasora',
    hasGroup: true,
    role: 'ocorrencia'
  },
  nematoide: {
    description: 'Nematóide',
    hasGroup: true,
    role: 'ocorrencia'
  },
  climatica: {
    description: 'Climática',
    hasGroup: true,
    role: 'ocorrencia'
  },
  manutencao_melhoria: {
    description: 'Manutenção/Melhorias',
    hasGroup: true,
    role: 'ocorrencia'
  },
  solo: {
    description: 'Solo',
    hasGroup: true,
    role: 'ocorrencia'
  },
  inimigo_natural: {
    description: 'Inimigo Natural',
    hasGroup: true,
    role: 'ocorrencia'
  },
  recomendacao: {
    description: 'Recomendação',
    hasGroup: true,
    hasSide: true,
    role: 'recomendacao'
  },
  aplicacao: {
    description: 'Pulverização',
    hasGroup: true,
    isGeneral: true,
    hasSide: true,
    role: 'pulverizacao'
  },
  recomendacao_operacao_correcao_solo: {
    description: 'Correção de Solo',
    hasSide: true,
    hasGroup: true,
    role: 'recomendacao'
  },
  aspecto_geral: {
    description: 'Anotação',
    hasGroup: true,
    role: 'anotacao'
  },
  anotacao: {
    description: 'Anotação',
    hasGroup: true,
    role: 'anotacao'
  },
  tarefa: {
    description: 'Tarefa',
    hasGroup: true,
    hasSide: true,
    role: 'tarefa'
  },
  semeadura_afericao: {
    description: 'Semeadura Aferição',
    hasGroup: true,
    role: 'maquinas'
  },
  colheita_afericao: {
    description: 'Colheita Aferição',
    hasGroup: true,
    role: 'maquinas'
  },
  aplicacao_afericao: {
    description: 'Aplicação Aferição',
    hasGroup: true,
    role: 'maquinas'
  }
};

window.TYPES_STATUS_OPERATIONS_NATURAL_ENEMY = {
  neutro: {
    colorDescription: 'branco'
  },
  equilibrio: {
    colorDescription: 'vermelho'
  },
  alto_equilibrio: {
    colorDescription: 'branco'
  },
  controle: {
    colorDescription: 'amarelo'
  },
  alerta: {
    colorDescription: 'verde'
  },
  emergencia: {
    colorDescription: 'verde'
  },
  extremo: {
    colorDescription: 'branco'
  }
};

window.ICON_ALERT_PATH = 'images/marker-icons/';
window.ICON_ALERT_ANCHOR = {
  0: [0, 0],
  1: [27, 0],
  2: [-27, 0],
  3: [0, 30],
  4: [0, -30]
};

window.TIPOS_OPERACAO_OCORRENCIAS = ['inseto', 'invasora', 'doenca', 'nematoide', 'inimigo_natural'];
window.TIPOS_OPERACAO_RECOMENDACAO_PULVERIZACAO = ['recomendacao', 'aplicacao'];

/* eslint-disable */
angular.module('webAgro1App').factory('OperacoesDadosService', function($filter, $compile, $rootScope,
  MapaService, CalculationService, AtividadesService, InfoWindowService, ContagensService, LeafletService, UtilsService) {

  function getMarkerValuesFromOperation(objeto, data) {
    function withoutCultivar(objeto) {
      objeto.cultivarForGroup = {
        id: 0,
        descricao: null
      };
      return objeto;
    }

    function withCultivar(objeto) {
      objeto.cultivarForGroup = {
        id: objeto.params.cd_insumo,
        tipo: 1,
        descricao: objeto.cultivar
      };
      return objeto;
    }

    return {
      stand: function(){
        objeto.template = 'info-stand.html';
        objeto.stand = true;
        objeto.ideal = data.densidade_ideal;
        objeto.realized = objeto.density;
        objeto.variation = CalculationService.getVariation(data.densidade_ideal, objeto.density);
        objeto.unitDescription = 'pl/ha';
        objeto.title = 'Contagem Stand';
        objeto.isWheat = AtividadesService.isWheat(objeto.atividade);
        objeto.isCorn = AtividadesService.isCorn(objeto.atividade);
        objeto.isAlgodao = AtividadesService.isAlgodao(objeto.atividade);
        objeto.isCana = AtividadesService.isCana(objeto.atividade);
        if (objeto.isCana) {
          objeto.template = 'info-stand-cana.html';
        }
        return withCultivar(objeto);
      },
      produtividade: function(){
        objeto.isWheat = AtividadesService.isProdutividadeLikeWheat(objeto.atividade);
        objeto.isCorn = AtividadesService.isCorn(objeto.atividade);
        objeto.isAlgodao = AtividadesService.isAlgodao(objeto.atividade);
        objeto.template = 'info-produtividade.html';
        objeto.templateItem = this.getTemplateItem(objeto);
        objeto.produtividade = true;
        objeto.nameSamples = this.getNameSamples(objeto);
        objeto.ideal = data.produtividade_alvo;
        objeto.realized = objeto.fertility;
        objeto.variation = CalculationService.getVariation(data.produtividade_alvo, objeto.fertility);
        objeto.unitDescription = this.getUnitDescription(objeto);
        objeto.title = 'Estimativa de Produtividade';
        objeto.medias = ContagensService.getWheatAverages(objeto.samples, objeto.area);
        return withCultivar(objeto);
      },
      getTemplateItem(objeto) {
        if (AtividadesService.isProdutividadeLikeWheat(objeto.atividade)) {
          return 'info-produtividade-trigo-item.html';
        } else if (objeto.isCorn) {
          return 'info-produtividade-milho-item.html';
        } else if (objeto.isAlgodao) {
          return 'info-produtividade-algodao-item.html';
        } else if (objeto.isCana) {
          return 'info-produtividade-cana-item.html';
        }
        return 'info-produtividade-item.html';
      },
      getNameSamples(objeto) {
        if (AtividadesService.isProdutividadeLikeWheat(objeto.atividade) || objeto.isAlgodao || objeto.isCorn) {
          return 'Linhas';
        }
        return 'Plantas';
      },
      getUnitDescription(objeto) {
        if (objeto.isAlgodao) {
          return '@/ha';
        }

        if (objeto.isCana) {
          return 'ton/ha';
        }

        return 'sc/ha';
      },
      ocorrencia: function(){
        objeto.template = 'info-ocorrencia.html';
        return withCultivar(objeto);
      },
      inseto: function(){
        objeto.title = 'Inseto';
        return this.ocorrencia();
      },
      doenca: function(){
        objeto.title = 'Doença';
        return this.ocorrencia();
      },
      invasora: function(){
        objeto.title = 'Invasora';
        return this.ocorrencia();
      },
      nematoide: function(){
        objeto.title = 'Nematóide';
        return this.ocorrencia();
      },
      inimigo_natural: function(){
        objeto.title = 'Inimigo Natural';
        return this.ocorrencia();
      },
      climatica: function() {
        objeto.title = 'Climática';
        return this.ocorrencia();
      },
      manutencao_melhoria: function() {
        objeto.title = 'Manutenção e Melhoria';
        return this.ocorrencia();
      },
      solo: function() {
        objeto.title = 'Solo';
        return this.ocorrencia();
      },
      massa_seca_pastagem: function(){
        objeto.title = 'Massa Seca de Pastagem';
        return this.ocorrencia();
      },
      aplicacao: function() {
        objeto.recomendacao_uso_defensivo = data.recomendacao.recomendacao_uso_defensivo || {};
        return withoutCultivar(objeto);
      },
      recomendacao: function() {
        return withoutCultivar(objeto);
      },
      tratamento_semente: function() {
        return withoutCultivar(objeto);
      },
      recomendacao_operacao_correcao_solo: function() {
        return withoutCultivar(objeto);
      },
      anotacao: function() {
        objeto.template = 'info-aspecto-geral.html';
        objeto.title = 'Anotação';
        return withCultivar(objeto);
      },
      colheita_afericao: function() {
        objeto.template = 'colheita_afericao.html';
        objeto.title = 'Aferição de Colheita';
        return withoutCultivar(objeto);
      },
      semeadura_afericao: function() {
        objeto.template = 'semeadura_afericao.html';
        objeto.title = 'Aferição de Semeadura';
        return withoutCultivar(objeto);
      },
      aplicacao_afericao: function() {
        objeto.template = 'aplicacao_afericao.html';
        objeto.title = 'Aferição de Aplicação';
        return withoutCultivar(objeto);
      }
    };
  }

  return {

    getImagesObject: function(images, noImageDefault) {
      var result = [];

      images = (images || []).filter(Boolean);
      if (images && images.length > 0) {
        result = images.map(function(data, index) {
          return {
            id: index,
            idOriginal: data.id,
            thumb: UtilsService.getUrl(data.imagem_thumb_url),
            report: UtilsService.getUrl(data.imagem_report_url),
            url: UtilsService.getUrl(data.imagem_url)
          };
        });
      } else if (!noImageDefault) {
        result = [{
          id: 0,
          thumb: IMG_NO_IMAGE,
          url: IMG_NO_IMAGE,
          noImage: true
        }];
      }
      return result;
    },

    getAudioObject: function(audio) {
      var result = null;
      if (audio && audio.audio) {
        result = {
          id: audio.audio.id
        }
        if (audio.audio.audio_url) {
          result.url = UtilsService.getUrl(audio.audio.audio_url);
        }
        if (audio.audio.audio_ogg_url) {
          result.ogg_url = UtilsService.getUrl(audio.audio.audio_ogg_url)
        }
      }

      return result;
    },

    getIconAlert: function(type, status) {
      status = status || 'equilibrio';
      type = String(type).toLowerCase();
      status = String(status).toLowerCase();

      let typeOperation = (TYPES_STATUS_OPERATIONS[status] || TYPES_STATUS_OPERATIONS.equilibrio);
      if(type === 'inimigo_natural') {
        typeOperation = (TYPES_STATUS_OPERATIONS_NATURAL_ENEMY[status] || TYPES_STATUS_OPERATIONS_NATURAL_ENEMY.alerta);
      }

      return ICON_ALERT_PATH + 'icon_' + type + '_' + typeOperation.colorDescription + '.png';
    },

    createAlertMarker: function(type, status, count, polygon) {
      if (!type || !status || !polygon) {
        return {};
      }
      count = count || 0;
      var coordinateCenter = MapaService.getCoordinateCentroid(polygon.path);
      var idKey = polygon.gleba.id + '.' + count;
      var iconUrl = this.getIconAlert(type, status);
      var anchor = ICON_ALERT_ANCHOR[count];
      var iconAnchor = new google.maps.Point(anchor[0],anchor[1]);

      return {
        idKey: idKey,
        coords: coordinateCenter,
        options: {
          animation: google.maps.Animation.DROP,
          icon: {
            url: iconUrl,
            anchor: iconAnchor,
            origin: new google.maps.Point(0,0),
            scaledSize: new google.maps.Size(32,36)
          }
        }
      };
    },

    newGetMarkersOperationsDayGleba: function(data, map, templateInfoWindow) {
      var _this = this;
      var allMarkers = [];
      var allLeafletMarkers = [];
      return data.map(function(registro) {
        var id = new Date().getTime();
        var objeto = JSON.parse(registro.objeto);
        var tipo = registro.tipo;

        if (tipo === 'geral') {
          tipo = 'anotacao';
        }

        objeto = getMarkerValuesFromOperation(objeto, registro)[tipo]();
        objeto.sincId = registro.id || 0;

        objeto.id = objeto.id || id;
        objeto.sincObjectId = registro.sincObjectId;
        objeto.map = map;
        objeto.subtipo = objeto.subtipo || objeto.tipo;
        objeto.tipo_medida = objeto.tipo_medida || objeto.input;
        objeto.accuracy = objeto.accuracy || objeto.precisao;
        objeto.tipo = registro.tipo;
        objeto.status = registro.situacao;
        objeto.created_at = registro.created_at;
        objeto.images = _this.getImagesObject(registro.imagens);
        objeto.audio = _this.getAudioObject(registro.audio);
        objeto.position = {
          lat: parseFloat(objeto.latitude),
          lng: parseFloat(objeto.longitude)
        };

        objeto.icon = registro.icon || _this.getIconAlert(registro.tipo, registro.classificacao);
        objeto.color = (TYPES_STATUS_OPERATIONS[registro.classificacao] || TYPES_STATUS_OPERATIONS.equilibrio).color;

        if (registro.tipo === 'produtividade' || registro.tipo === 'stand') {
          objeto.registroId = registro.id;
          objeto.registroAtivo = registro.ativo;
          objeto.plantasPorMetrosQuadrados = registro.contagem/10000;
          if (!objeto.registroAtivo) {
            objeto.icon = registro.icon || _this.getIconAlert(registro.tipo, 'neutro');
            objeto.color = (TYPES_STATUS_OPERATIONS.neutro).color;
          }
        }

        objeto.classificacao = registro.classificacao;
        objeto.animation = google.maps.Animation.DROP;
        var marker = new google.maps.Marker(objeto);
        allMarkers.push(marker);
        var leafletMarker;
        if (objeto.position.lat && objeto.position.lng) {
          leafletMarker = LeafletService.createMarker([objeto.position.lat, objeto.position.lng], objeto.icon);
          leafletMarker.objeto = objeto;
          allLeafletMarkers.push(leafletMarker);
        }

        var infoWindow = null;
        if (templateInfoWindow) {
          InfoWindowService.createInfoWindow(templateInfoWindow, marker, objeto, leafletMarker);
        }

        objeto.allMarkers = allMarkers;
        objeto.allLeafletMarkers = allLeafletMarkers;

        return {
          marker: marker,
          infoWindow: infoWindow,
          objeto: objeto,
          leafletMarker
        };
      });
    },

    getOperationsGroupFromMarkers: function(data) {
      var operationsGroup = {};

      var setOperationsKeysGroup = function() {
        var keysOperations = Object.keys(TYPES_DESCRIPTIONS_OPERATIONS);
        for (var i = 0; i <= keysOperations.length-1; i++) {
          if (TYPES_DESCRIPTIONS_OPERATIONS[keysOperations[i]].hasGroup) {
            var key = keysOperations[i];
            operationsGroup[key] = {
              tipo: key,
              descricao: TYPES_DESCRIPTIONS_OPERATIONS[key].description,
              cultivares: {}
            };
          }
        }
      };

      var addCultivar = function(key, marker) {
        var cultivarId = marker.cultivarForGroup.id;
        var atividade_id = (marker.params ? marker.params.atividade_id : marker.cd_atividade) || 0;
        if (!operationsGroup[key].cultivares[cultivarId]) {
          operationsGroup[key].cultivares[cultivarId] = {
            id: marker.cultivarForGroup.id,
            tipo: 1,
            descricao: marker.cultivarForGroup.descricao,
            atividade_id: atividade_id,
            markers: []
          };
        }
        operationsGroup[key].cultivares[cultivarId].markers.push(marker);
      };

      setOperationsKeysGroup();
      for (var i = data.length-1; i >= 0; i--) {
        var key = data[i].tipo;
        if (operationsGroup[key]) {
          addCultivar(key, data[i]);
        }
      }

      return operationsGroup;
    },

    getTypesOperationsOccurrence: function() {
      return ['inseto', 'doenca', 'invasora', 'nematoide', 'inimigo_natural'];
    }
  };
});
